import {BenefitDetail, BenefitGroup} from '../../domain/scan/entities/BenefitDetail';

interface BenefitDetailResponse {
  id: number;
  program_id: number;
  description: string;
  type: string;
  cost: number;
  units: number;
  start_date: string | null;
  end_date: string | null;
  disabled: boolean;
  deleted: boolean;
  total_groups: number;
  total_documents: number;
  groups: Array<{
    id: number;
    benefit_id: number;
    rules_data: Array<{
      field: string;
      operador: string;
      value: string;
    }>;
    documents_data: any[];
    disabled: boolean;
    deleted: boolean;
    created_at: string;
    updated_at: string;
  }>;
  created_at: string;
  created_by_id: number;
  updated_at: string;
}

/**
 * Maps a benefit group from API response to domain entity
 */
const mapBenefitGroup = (group: BenefitDetailResponse['groups'][0]): BenefitGroup => {
  return {
    id: group.id,
    benefitId: group.benefit_id,
    rulesData: group.rules_data || [],
    documentsData: group.documents_data || [],
    disabled: group.disabled,
    deleted: group.deleted,
    createdAt: new Date(group.created_at),
    updatedAt: new Date(group.updated_at),
  };
};

/**
 * Maps benefit detail response from API to domain entity
 * @param response - Benefit detail response from API
 * @returns BenefitDetail domain entity
 */
export const mapBenefitDetailResponse = (response: BenefitDetailResponse): BenefitDetail => {
  return {
    id: response.id,
    programId: response.program_id,
    description: response.description,
    type: response.type,
    cost: response.cost,
    units: response.units,
    startDate: response.start_date ? new Date(response.start_date) : null,
    endDate: response.end_date ? new Date(response.end_date) : null,
    disabled: response.disabled,
    deleted: response.deleted,
    totalGroups: response.total_groups,
    totalDocuments: response.total_documents,
    groups: response.groups?.map(mapBenefitGroup) || [],
    createdAt: new Date(response.created_at),
    createdById: response.created_by_id,
    updatedAt: new Date(response.updated_at),
  };
};
